import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';

export const useTopicalMaps = () => {
  const [isGenerating, setIsGenerating] = useState(false);
  const queryClient = useQueryClient();

  // Fetch topical maps
  const { data: topicalMaps, isLoading, refetch } = useQuery({
    queryKey: ['topical-maps'],
    queryFn: async () => {
      const response = await api.get('/api/marketing/topical-maps/');
      return (response.data as any).results || response.data;
    }
  });

  // Generate topical map mutation
  const generateMutation = useMutation({
    mutationFn: async (topPageId: number) => {
      const response = await api.post(`/api/marketing/topical-maps/generate/`, {
        top_page_id: topPageId
      });
      return response.data;
    },
    onMutate: () => {
      setIsGenerating(true);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['topical-maps'] });
      queryClient.invalidateQueries({ queryKey: ['content-stats'] });
    },
    onError: (error: any) => {
      alert(error.response?.data?.detail || 'Failed to generate topical map');
    },
    onSettled: () => {
      setIsGenerating(false);
    }
  });

  // Approve topical map mutation
  const approveMutation = useMutation({
    mutationFn: async (mapId: number) => {
      const response = await api.post(`/api/marketing/topical-maps/${mapId}/approve/`, {});
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['topical-maps'] });
    },
    onError: (error: any) => {
      alert(error.response?.data?.detail || 'Failed to approve topical map');
    }
  });

  // Archive topical map mutation
  const archiveMutation = useMutation({
    mutationFn: async (mapId: number) => {
      const response = await api.patch(`/api/marketing/topical-maps/${mapId}/`, {
        status: 'archived'
      });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['topical-maps'] });
    },
    onError: (error: any) => {
      alert(error.response?.data?.detail || 'Failed to archive topical map');
    }
  });

  return {
    topicalMaps,
    isLoading,
    isGenerating,
    generateTopicalMap: generateMutation.mutate,
    approveTopicalMap: approveMutation.mutate,
    archiveTopicalMap: archiveMutation.mutate,
    refetch
  };
};